import { Row, Spin } from 'antd'
import { useEffect, useState } from 'react'
import PageTitle from '../../../components/PageTitle'
import { useSearchParams } from 'react-router-dom'
import { AuthorizationResult, AuthorizationResultCode } from '../types'

const InstagramRedirect = () => {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'failure'>(
    'loading'
  )

  useEffect(() => {
    const code = searchParams.get('code')
    let message: AuthorizationResult

    if (code === null) {
      setStatus('failure')
      message = {
        initiator: 'SB Authorization Modal',
        eventType: AuthorizationResultCode.AUTHORIZATION_FAILED,
        data: { code: undefined },
      }
    } else {
      setStatus('success')
      message = {
        initiator: 'SB Authorization Modal',
        eventType: AuthorizationResultCode.AUTHORIZATION_SUCEEDED,
        data: { code: code },
      }
    }

    // Tell the world what happened
    window.opener && window.opener.postMessage(message, '*')

    // Close the modal
    window.setTimeout(function () {
      window.close()
    }, 300)
  }, [searchParams])

  return (
    <Row gutter={[16, 16]}>
      <PageTitle title="Instagram redirect" showButton={false} />
      {status === 'loading' && <Spin />}
      {status === 'failure' && <>ERROR</>}
      {status === 'success' && <>SUCCESS</>}
    </Row>
  )
}

export default InstagramRedirect
